__turbopack_context__.v({
  "bounce": "eBHctW_bounce",
  "container": "eBHctW_container",
  "count": "eBHctW_count",
  "countBounce": "eBHctW_countBounce",
  "countSm": "eBHctW_countSm",
});
